import { getLink } from "../../../../utils/utils";

import translator from "../translator";

const content = {
	esp: (
		`
		<p class="mb-3">
			Sentante, ke ŝia beleco komencas velki, kaj dezirante iel daŭrigi sian someron, la Betulo kolorigis sin je la plej moda en la aŭtuna sezono koloro – la flava.
		</p>
		
		<p class="mb-3">
			Kaj tiam ĉiuj ekvidis, ke ŝia aŭtuno jam venis.
		</p>
		`
	)
}

const itemName = {
	esp: 'La aŭtuno'
}

const item = {
	itemlink: getLink(itemName.esp),
	esp: {
		itemName: itemName.esp,
		itemContent: content.esp,
		itemTranslator: translator.esp
	}
}

export default item;